import { Link } from 'react-router-dom';
import { useContext } from "react";
import AppMenu from "./AppMenu";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";
import { LayoutState } from "../../types/layout";
import flexweighLogo from "./amanziLytics.png";


const AppSidebar = () => {
    const { setLayoutState, layoutConfig } = useContext(LayoutContext);
    const anchor = () => {
        setLayoutState((prevLayoutState: LayoutState) => ({
            ...prevLayoutState,
            anchored: !prevLayoutState.anchored,
        }));
    };
    return (
        <>
            <div className="sidebar-header">
                <Link to="/" className="app-logo">
                    <img 
                        src={flexweighLogo} 
                        alt="logo"
                        style={{
                            width: "100px",       // Adjust size as needed (e.g., 30px, 50px, 80px)
                            height: "60px",    // Maintain aspect ratio
                            mixBlendMode: "normal",
                            filter: layoutConfig?.colorScheme === "dark" ? "brightness(1.2) contrast(1.1)" : "none",
                        }}
                    />
                </Link>
                <button
                    className="layout-sidebar-anchor p-link z-2 mb-2"
                    type="button"
                    onClick={anchor}
                ></button>
            </div>

            <div className="layout-menu-container">
                <MenuProvider>
                    <AppMenu />
                </MenuProvider>
            </div>
        </>
    );
};

export default AppSidebar;
